var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.5C2.90841 15.4895 7.27366 7.66208 6.37051 3.1463C5.46735 -1.36948 0.951578 0.436963 0.951578 4.50109C0.951578 8.56523 2.30631 11.7265 5.01578 13.0811C7.72524 14.4357 8.6284 7.21049 10.4347 10.1007C12.241 12.9908 10.8863 14.4357 9.98313 13.5326C9.07997 12.1778 10.8863 8.56523 12.6926 8.56523C14.4989 8.56523 14.9505 11.2747 16.3052 11.2747C17.6599 11.2747 18.5631 9.91996 18.5631 9.91996",
    stroke: "#47793E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37061 17.5967H15.8537",
    stroke: "#47793E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureGreen);
export default __webpack_public_path__ + "static/media/signature-green.e864d85910326ce784ac708b54ceecd3.svg";
export { ForwardRef as ReactComponent };